// shared/pdf/components/PdfSignatureBlock.jsx
import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  wrap:  { flexDirection: 'row', justifyContent: 'space-between', marginTop: 40, paddingHorizontal: 20 },
  box:   { alignItems: 'center', width: 140 },
  line:  { width: 120, borderTopWidth: 0.7, marginBottom: 4 },
  label: { fontSize: 8, fontFamily: 'NotoSans', textAlign: 'center' },
});

export default function PdfSignatureBlock({ theme }) {
  return (
    <View style={styles.wrap}>
      <View style={styles.box}>
        <View style={[styles.line, { borderTopColor: theme.muted }]} />
        <Text style={[styles.label, { color: theme.muted }]}>Receiver's Signature</Text>
      </View>
      <View style={styles.box}>
        <View style={[styles.line, { borderTopColor: theme.muted }]} />
        <Text style={[styles.label, { color: theme.muted }]}>Authorised Signatory</Text>
      </View>
    </View>
  );
}
